<div class="account-panel">
  <div class="account-panel-header">
    <h2 class="account-panel-title">{{ titleKey | translate : { fgbdefault: titleDefault } }}</h2>
  </div>
  <div class="account-panel-content">
    <ng-content></ng-content>
  </div>
</div>
